export default `
varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;

varying vec3 vPosition;
varying vec3 vWorldPosition;

void main(){
  vUv = uv;
  vNormal = normal;
  vNormal2 = normalize(normalMatrix * normal);
  vPosition = position;

  vec4 worldPos = modelMatrix * vec4(position, 1.0);
  vec4 screenPos = projectionMatrix * viewMatrix * worldPos;
  vWorldPosition = worldPos.xyz;

  gl_Position = screenPos;
}
`
